import React, { useState, useEffect } from 'react';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import StorageManager from '../context/StorageManager';
import Swal from 'sweetalert2';
import { Card, Spinner, Button, Tab, Nav } from 'react-bootstrap';
import { useProvider, Toast } from '../context/MenuProvider';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';

const Gestao = () => {
  const { 
    hasPerms,
    hasPermsAnd,
  } = useProvider();
  const { tipo, id } = useParams(); 
  const navigate = useNavigate();
  const [formType, setFormType] = useState(tipo);
  
 
  useEffect(()=>{
    if(tipo !== formType){
      navigate(`/painel/gestao/${formType}`,{replace:true})
    }
  },[formType])

  // Monta os itens com base nas permissões
  const navItems = [
    hasPerms([
      "loja.view_produtos",
      "loja.view_venda",
    ]) && {
      key: "vendas",
      icon: "bx bx-shopping-bag",
      label: "Gestão de Vendas",
      component: <GestaoVendas />
    },
    hasPerms([
      "rede.view_apn",
      "rede.view_prospecto",
      "rede.view_consultor", 
    ]) && {
      key: "rede",
      icon: "bx bx-sitemap",
      label: "Gestão de Rede",
      component: <GestaoRede />
    },
    hasPerms([
      "financas.view_financeiro",
    ]) && {
      key: "financas",
      icon: "bx bx-dollar",
      label: "Gestão Financeira",
      component: <GestaoPessoal />
    }
  ].filter(Boolean); // remove os falsos
  
  useEffect(()=>{
    if (!tipo && navItems?.length){
      setFormType(navItems[0].key);
    }
  },[navItems])

  return (
    <>
      <Tab.Container id="details-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
        
        {/* Só renderiza se houver mais de 1 item */}
        {navItems.length > 1 && (
          <Nav variant="tabs" className="justify-content-center d-flex flex-nowrap overflow-auto">
            {navItems.map(item => (
              <Nav.Item key={item.key}>
                <Nav.Link eventKey={item.key} className="text-center">
                  <i className={`${item.icon} fs-1 text-dark`}></i>
                  <div className="small text-muted">{item.label}</div>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        )}

        <Tab.Content>
          {navItems.map(item => (
            <Tab.Pane key={item.key} eventKey={item.key}>
              {item.component}
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

const GestaoVendas = () => {
  const [clientesSemCompra, setClientesSemCompra] = useState(0);
  const [totalClientes, setTotalClientes] = useState(0); // Correção aqui
  const [quantidadeEstoque, setQuantidadeEstoque] = useState(0);
  const [valorLucroEstoque, setValorLucroEstoque] = useState(0);
  const [valorCustoEstoque, setValorCustoEstoque] = useState(0);
  const [valorTotalEstoque, setValorTotalEstoque] = useState(0);
  const [totalAberto, setTotalAberto] = useState(0);
  const [vendasCount, setVendasCount] = useState(0);
  const [faturamentoEsteMes, setFaturamentoEsteMes] = useState(0);
  const [extras, setExtras] = useState({});
  
  const { 
    setLinks, 
    setBtns,
    btns,
    crud,
    hasPerms,
    buscarDadosPorId,
    salvarDados,
  } = useProvider();
  const {get, loading} = crud || {};
  
  const navigate = useNavigate();

  
  useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  
  useEffect(() => {
    setLinks([
        { name: 'Nova Venda', to: '/vendas/novo' },
        { name: 'Novo Produto', to: '/produtos/novo' },
        { name: 'Novo Cliente', to: '/clientes/novo' },
        //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    setBtns([
        {icon:'bx-cog', to:`/config/funcoes`},
    ]);
    return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns]);
  
  // Usar um objeto Date para obter ano e mês
  const dataAtual = new Date();
  const hoje = dataAtual.toLocaleDateString('sv-SE');

  // Primeiro dia do mês atual
  const primeiroDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1).toLocaleDateString('sv-SE');
  
  // Último dia do mês atual
  const ultimoDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0).toLocaleDateString('sv-SE');

  
  const carregarModel = (response) => {
        //alert(JSON.stringify(response[0].extra))
        setClientesSemCompra(response[3]?.count || 0);
        setTotalClientes(response[1]?.count || 0);
        setQuantidadeEstoque(response[0]?.extra?.estoque || 0);
        setValorCustoEstoque(response[0]?.extra?.total_custo || 0);
        setValorLucroEstoque(response[0]?.extra?.total_lucro || 0);
        setValorTotalEstoque(response[0]?.extra?.total_valor || 0);
        setTotalAberto(response[2]?.extra?.total_aberto || 0);
        setVendasCount(response[2]?.count || 0);
        setFaturamentoEsteMes(response[4]?.extra?.total || 0);
        setExtras(response[2].extra);
  }
  
  const buscarModelDB = async () =>  {
    const response = await buscarDadosPorId('local_registros','gestao');
    if (response){
      //alert(`Carregar: ${JSON.stringify(response)}`)
      carregarModel(response)
    }
  }
  const gravarModelDB = (response) =>  {
      //alert(`Gravar ${JSON.stringify(response)}`)
      salvarDados('local_registros',{
        ...response,
        id:'gestao'
      });
  }
  
  const buscarGestao = async () => {
    const data = new Date();
    data.setDate(data.getDate() - 60);
    let data_ultima_compra = data.toLocaleDateString('sv-SE');
    
    const urls = [
      '/gvendas/produtos/?is_ativo=true&expand=extra&filtros=id&limit=1', 
      '/gvendas/clientes/?numero_de_compras__gt=0&ativo=true&filtros=id&limit=1',
      `/gvendas/vendas/?cliente__ativo=true&total_aberto__gt=0&expand=extra&filtros=id&limit=1`,
      `/gvendas/clientes/?numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lt=${data_ultima_compra}&ativo=true&filtros=id&limit=1`,
      `/gvendas/pagamentos/?venda__isnull=false&data_do_pagamento__gte=${primeiroDia}&data_do_pagamento__lte=${ultimoDia}&pago=true&expand=extra&filtros=id&limit=1`
    ];
    try{
      const response = await get(urls, 'pagina');
      if(response && response.length){
        carregarModel(response);
        gravarModelDB(response);
      }
    }catch(err){
      // Toast.fire({
      //   icon: "error",
      //   title: "Falha ao buscar gestão"
      // });
    }finally{
      
    }
  };
  
  useEffect(() => {
    buscarModelDB();
    buscarGestao();
  }, []); // Adiciona dependência ao token

  return (
    <>
      <div className="list-group">
          <>
            <div data-aos="fade-up">
              <RenderizarProduto 
                  to='/vendas' 
                  icon='bi-cart'
                  text2={`${parseFloat(totalAberto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} pendentes de pagamento`} // Exibe a quantidade real de estoque
                  titulo={`Minhas Vendas (${vendasCount})`} 
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={100}>
              <RenderizarProduto 
                  to='/clientes' 
                  icon='bi-people'
                  text2={`${clientesSemCompra} mais de 60 dias sem comprar`} // Exibe a quantidade real de estoque
                  titulo={`Meus Clientes (${totalClientes})`} 
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={200}>
              <RenderizarProduto 
                  to='/produtos' 
                  icon='bi-box-seam'
                  text2={`Custo: ${parseFloat(valorCustoEstoque||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} | Lucro: ${parseFloat(valorLucroEstoque||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`} // Exibe a quantidade real de estoque
                  titulo={`Estoque (${quantidadeEstoque})`}
                  titulo2={parseFloat(valorTotalEstoque||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={300}>
              <RenderizarProduto 
                  to='/pagamentos/receita/todos' 
                  icon='bi-cash-stack'
                  text2={`${parseFloat(faturamentoEsteMes||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} de faturamento este mês`} // Exibe a quantidade real de estoque
                  titulo={`Meus Recebimentos`}
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={400}>
              <RenderizarProduto 
                  to='/relatorios?tipo=venda' 
                  icon='bx bx-food-menu'
                  //text2={`${parseFloat(extras?.valor_total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em produtos este mês`} // Exibe a quantidade real de estoque
                  text2="Relatório personalizado para vendas e produtos"
                  titulo={`Relatórios `}
              />
            </div>
          </>
      </div>
    </>
  );
}

const GestaoRede = () => {
  const [clientesSemCompra, setClientesSemCompra] = useState(0);
  const [totalClientes, setTotalClientes] = useState(0); // Correção aqui
  const [quantidadeEstoque, setQuantidadeEstoque] = useState(0);
  const [valorLucroEstoque, setValorLucroEstoque] = useState(0);
  const [valorCustoEstoque, setValorCustoEstoque] = useState(0);
  const [valorTotalEstoque, setValorTotalEstoque] = useState(0);
  const [totalAberto, setTotalAberto] = useState(0);
  const [vendasCount, setVendasCount] = useState(0);
  const [faturamentoEsteMes, setFaturamentoEsteMes] = useState(0);
  const [extras, setExtras] = useState({});

  const { 
    setLinks, 
    setBtns,
    crud,
    hasPerms,
    buscarDadosPorId,
    salvarDados,
  } = useProvider();
  const {get, loading} = crud || {};
  
  const navigate = useNavigate();
  useEffect(() => {
      navigate({replace:true})
  }, [navigate]);
  
  useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  
  useEffect(() => {
    setLinks([
        { name: 'Novo Prospecto', to: '/vendas/novo' },
        { name: 'Novo Evento', to: '/produtos/novo' },
        { name: 'Nova APN', to: '/clientes/novo' },
        //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    setBtns([
        {icon:'bx-cog', to:`/config/funcoes`},
    ]);
    return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns]);
  
  // Usar um objeto Date para obter ano e mês
  const dataAtual = new Date();
  const hoje = dataAtual.toLocaleDateString('sv-SE');

  // Primeiro dia do mês atual
  const primeiroDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1).toLocaleDateString('sv-SE');
  
  // Último dia do mês atual
  const ultimoDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0).toLocaleDateString('sv-SE');

  
  const carregarModel = (response) => {
        //alert(JSON.stringify(response[0].extra))
        setClientesSemCompra(response[3]?.count || 0);
        setTotalClientes(response[1]?.count || 0);
        setQuantidadeEstoque(response[0]?.extra?.estoque || 0);
        setValorCustoEstoque(response[0]?.extra?.total_custo || 0);
        setValorLucroEstoque(response[0]?.extra?.total_lucro || 0);
        setValorTotalEstoque(response[0]?.extra?.total_valor || 0);
        setTotalAberto(response[2]?.extra?.total_aberto || 0);
        setVendasCount(response[2]?.count || 0);
        setFaturamentoEsteMes(response[4]?.extra?.total || 0);
        setExtras(response[2].extra);
  }
  
  const buscarModelDB = async () =>  {
    const response = await buscarDadosPorId('local_registros','gestao');
    if (response){
      //alert(`Carregar: ${JSON.stringify(response)}`)
      carregarModel(response)
    }
  }
  const gravarModelDB = (response) =>  {
      //alert(`Gravar ${JSON.stringify(response)}`)
      salvarDados('local_registros',{
        ...response,
        id:'gestao'
      });
  }
  
  const buscarGestao = async () => {
    const data = new Date();
    data.setDate(data.getDate() - 60);
    let data_ultima_compra = data.toLocaleDateString('sv-SE');
    
    const urls = [
      '/gvendas/produtos/?is_ativo=true&expand=extra&filtros=id&limit=1', 
      '/gvendas/clientes/?numero_de_compras__gt=0&ativo=true&filtros=id&limit=1',
      `/gvendas/vendas/?cliente__ativo=true&total_aberto__gt=0&expand=extra&filtros=id&limit=1`,
      `/gvendas/clientes/?numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lt=${data_ultima_compra}&ativo=true&filtros=id&limit=1`,
      `/gvendas/pagamentos/?venda__isnull=false&data_do_pagamento__gte=${primeiroDia}&data_do_pagamento__lte=${ultimoDia}&pago=true&expand=extra&filtros=id&limit=1`
    ];
    try{
      const response = await get(urls, 'pagina');
      if(response && response.length){
        carregarModel(response);
        gravarModelDB(response);
      }
    }catch(err){
      // Toast.fire({
      //   icon: "error",
      //   title: "Falha ao buscar gestão"
      // });
    }finally{
      
    }
  };
  
  useEffect(() => {
    buscarModelDB();
    buscarGestao();
  }, []); // Adiciona dependência ao token

  return (
    <>
      <div className="list-group">
          <>
            <div data-aos="fade-up" data-aos-delay={100}>
              <RenderizarProduto 
                  to='/rede/qualificado' 
                  icon='bi-person-vcard'
                  text2={`Lista de contatos qualificados`} // Exibe a quantidade real de estoque
                  titulo={`Prospectos (Antigo)`} 
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={100}>
              <RenderizarProduto 
                  to='/rede/prospectos/apresentar' 
                  icon='bi-person-vcard'
                  text2={`Lista de prospectos para apresentação`} // Exibe a quantidade real de estoque
                  titulo={`Prospectos`} 
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={200}>
              <RenderizarProduto 
                  to='/rede/apn' 
                  icon='bi-journals'
                  titulo={`APN's`}
                  text2={`Apresentação de negócios`} // Exibe a quantidade real de estoque
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={300}>
              <RenderizarProduto 
                  to='/agenda/evento' 
                  icon='bi-calendar4-week'
                  titulo={`Eventos`}
                  text2={`Próximos eventos`} // Exibe a quantidade real de estoque
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={300}>
              <RenderizarProduto 
                  to='/rede/equipe' 
                  icon='bi-people'
                  titulo={`Equipe`}
                  text2={`Equipe de parceiros de negócios`} // Exibe a quantidade real de estoque
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={300}>
              <RenderizarProduto 
                  to='/rede/mapa' 
                  icon='bx bx-sitemap'
                  titulo={`Mapa de Rede`}
                  text2={`Mapa geral da rede de parceiros`} // Exibe a quantidade real de estoque
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={400}>
              <RenderizarProduto 
                  to='/relatorios?tipo=rede' 
                  icon='bx bx-food-menu'
                  //text2={`${parseFloat(extras?.valor_total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em produtos este mês`} // Exibe a quantidade real de estoque
                  text2="Relatório personalizado para marketing de rede"
                  titulo={`Relatórios `}
              />
            </div>
          </>
      </div>
    </>
  );
}

const GestaoPessoal = () => {
  const [clientesSemCompra, setClientesSemCompra] = useState(0);
  const [totalClientes, setTotalClientes] = useState(0); // Correção aqui
  const [quantidadeEstoque, setQuantidadeEstoque] = useState(0);
  const [valorLucroEstoque, setValorLucroEstoque] = useState(0);
  const [valorCustoEstoque, setValorCustoEstoque] = useState(0);
  const [valorTotalEstoque, setValorTotalEstoque] = useState(0);
  const [totalAberto, setTotalAberto] = useState(0);
  const [vendasCount, setVendasCount] = useState(0);
  const [faturamentoEsteMes, setFaturamentoEsteMes] = useState(0);
  const [extras, setExtras] = useState({});

  const { 
    setLinks, 
    setBtns,
    crud,
    hasPerms,
    buscarDadosPorId,
    salvarDados,
  } = useProvider();
  const {get, loading} = crud || {};
  
  const navigate = useNavigate();
  useEffect(() => {
      navigate({replace:true})
  }, [navigate]);
  
  useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  useEffect(() => {
    setLinks([
        { name: 'Nova Despesa', to: '/vendas/novo' },
        // { name: 'Novo Produto', to: '/produtos/novo' },
        // { name: 'Novo Cliente', to: '/clientes/novo' },
        //{ name: 'Configurações', to: '/configuracoes' },
    ]);
    setBtns([
        {icon:'bx-cog', to:`/config/funcoes`},
    ]);

    return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns]);
  
  // Usar um objeto Date para obter ano e mês
  const dataAtual = new Date();
  const hoje = dataAtual.toLocaleDateString('sv-SE');

  // Primeiro dia do mês atual
  const primeiroDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1).toLocaleDateString('sv-SE');
  
  // Último dia do mês atual
  const ultimoDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0).toLocaleDateString('sv-SE');

  
  const carregarModel = (response) => {
        //alert(JSON.stringify(response[0].extra))
        setClientesSemCompra(response[3]?.count || 0);
        setTotalClientes(response[1]?.count || 0);
        setQuantidadeEstoque(response[0]?.extra?.estoque || 0);
        setValorCustoEstoque(response[0]?.extra?.total_custo || 0);
        setValorLucroEstoque(response[0]?.extra?.total_lucro || 0);
        setValorTotalEstoque(response[0]?.extra?.total_valor || 0);
        setTotalAberto(response[2]?.extra?.total_aberto || 0);
        setVendasCount(response[2]?.count || 0);
        setFaturamentoEsteMes(response[4]?.extra?.total || 0);
        setExtras(response[2].extra);
  }
  
  const buscarModelDB = async () =>  {
    const response = await buscarDadosPorId('local_registros','gestao');
    if (response){
      //alert(`Carregar: ${JSON.stringify(response)}`)
      carregarModel(response)
    }
  }
  const gravarModelDB = (response) =>  {
      //alert(`Gravar ${JSON.stringify(response)}`)
      salvarDados('local_registros',{
        ...response,
        id:'gestao'
      });
  }
  
  const buscarGestao = async () => {
    const data = new Date();
    data.setDate(data.getDate() - 60);
    let data_ultima_compra = data.toLocaleDateString('sv-SE');
    
    const urls = [
      '/gvendas/produtos/?is_ativo=true&expand=extra&filtros=id&limit=1', 
      '/gvendas/clientes/?numero_de_compras__gt=0&ativo=true&filtros=id&limit=1',
      `/gvendas/vendas/?cliente__ativo=true&total_aberto__gt=0&expand=extra&filtros=id&limit=1`,
      `/gvendas/clientes/?numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lt=${data_ultima_compra}&ativo=true&filtros=id&limit=1`,
      `/gvendas/pagamentos/?venda__isnull=false&data_do_pagamento__gte=${primeiroDia}&data_do_pagamento__lte=${ultimoDia}&pago=true&expand=extra&filtros=id&limit=1`
    ];
    try{
      const response = await get(urls, 'pagina');
      if(response && response.length){
        carregarModel(response);
        gravarModelDB(response);
      }
    }catch(err){
      // Toast.fire({
      //   icon: "error",
      //   title: "Falha ao buscar gestão"
      // });
    }finally{
      
    }
  };
  
  useEffect(() => {
    buscarModelDB();
    buscarGestao();
  }, []); // Adiciona dependência ao token

  return (
    <>
      <div className="list-group">
          <>
            <div data-aos="fade-up" data-aos-delay={100}>
              <RenderizarProduto 
                  to='/pagamentos/despesa/pessoais' 
                  icon='bi-layout-text-sidebar'
                  //text2={`${clientesSemCompra} na lista de contatos`} // Exibe a quantidade real de estoque
                  titulo={`Despesas pessoais`} 
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={100}>
              <RenderizarProduto 
                  to='/pagamentos/despesa/negocio' 
                  icon='bi-bank'
                  //text2={`${clientesSemCompra} custos`} // Exibe a quantidade real de estoque
                  titulo={`Custos do negócio`} 
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={200}>
              <RenderizarProduto 
                  to='/pagamentos/fluxo-de-caixa' 
                  icon='bi-currency-dollar'
                  titulo={`Fluxo de Caixa`}
                  text2={`Toda movimentação financeira do mês`} // Exibe a quantidade real de estoque
              />
            </div>
            <div data-aos="fade-up" data-aos-delay={400}>
              <RenderizarProduto 
                  to='/relatorios?tipo=pessoais' 
                  icon='bx bx-food-menu'
                  //text2={`${parseFloat(extras?.valor_total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em produtos este mês`} // Exibe a quantidade real de estoque
                  text2="Relatório personalizado para despesas pepessoais"
                  titulo={`Relatórios `}
              />
            </div>
          </>

      </div>
    </>
  );
}

export default Gestao;